import { cn } from "../lib/utils.ts";

export type MicMode = "handsFree" | "ptt";

interface Props {
  value: MicMode;
  onChange: (m: MicMode) => void;
}

const OPTIONS: { id: MicMode; label: string; hint: string }[] = [
  { id: "handsFree", label: "Hands-free", hint: "Tap to start, tap to stop" },
  { id: "ptt", label: "Push to talk", hint: "Hold the mic to speak" },
];

export function MicModeSelector({ value, onChange }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="Microphone mode"
      className="inline-flex bg-white/10 rounded-full p-1 gap-1"
    >
      {OPTIONS.map((o) => {
        const active = o.id === value;
        return (
          <button
            key={o.id}
            role="radio"
            aria-checked={active}
            title={o.hint}
            onClick={() => onChange(o.id)}
            className={cn(
              "px-3 py-1 rounded-full text-xs font-semibold transition-colors",
              active
                ? "bg-white text-canvas"
                : "text-white/80 hover:text-white hover:bg-white/10",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
